'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var SelectableCard = require('../SelectableCard.js');
var VisuallyHidden = require('../VisuallyHidden.js');
var index = require('../Icon/index.js');
var RadioCard_module = require('./RadioCard.module.css.js');
var Box = require('../layout/Box/Box.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const RadioCard = _ref => {
  let {
    selected = false,
    name,
    value,
    onChange,
    id,
    children
  } = _ref;
  const [focused, setFocused] = React.useState(false);
  return /*#__PURE__*/React__default["default"].createElement("label", {
    htmlFor: id
  }, /*#__PURE__*/React__default["default"].createElement(VisuallyHidden["default"], {
    id: id,
    as: "input",
    type: "radio",
    name: name,
    value: value,
    checked: selected ?? undefined,
    onFocus: () => setFocused(true),
    onBlur: () => setFocused(false),
    onChange: onChange
  }), /*#__PURE__*/React__default["default"].createElement(SelectableCard["default"], {
    selected: selected,
    focused: focused,
    as: "div"
  }, /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    display: "flex",
    gap: 4
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: RadioCard_module["default"].radioContainer
  }, selected ? /*#__PURE__*/React__default["default"].createElement(index.IconThemed, {
    icon: "RadioSelected"
  }) : /*#__PURE__*/React__default["default"].createElement(index.IconThemed, {
    icon: "RadioUnselected"
  })), /*#__PURE__*/React__default["default"].createElement("div", null, children))));
};

exports["default"] = RadioCard;
